// removed by extract-text-webpack-plugin
module.exports = {"header":"index-module__header___3qTJ0","layout":"index-module__layout___25x6r","content":"index-module__content___RRzXO","flash-wrapper":"index-module__flash-wrapper___35D4i","flashWrapper":"index-module__flash-wrapper___35D4i"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/app/layout/index.module.scss
// module id = 1552
// module chunks = 146